import { OptionsObject, useSnackbar } from 'notistack';
import { IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import React, { ReactElement } from 'react';

export default function useClosableSnackbar() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  function showSnackbar(
    value: string | ReactElement,
    options: OptionsObject = {}
  ) {
    enqueueSnackbar(value, {
      ...options,
      variant: 'info',
      action: (
        <IconButton aria-label="close" onClick={() => closeSnackbar()}>
          <Close style={{ color: 'white' }} />
        </IconButton>
      ),
    });
  }

  return { showSnackbar };
}
